import { useEffect } from 'react';

import { Sim } from '@generated/gql/graphql';
import { useSyncState } from '@hooks/useSyncState';
import { useAppointmentContext } from '@providers/AppointmentProvider/AppointmentContext';

import { subscribeToSims, useSimsStore } from '../store';

export const useSyncSims = () => {
  const { loadSims } = useSimsStore();
  const [sims, setSims] = useSyncState<Sim[]>('selected-sims', []);
  const { hasControl, isSyncedAppointment } = useAppointmentContext();

  useEffect(() => {
    return subscribeToSims((sims) => {
      if (hasControl && isSyncedAppointment) {
        setSims(sims);
      }
    });
  }, [hasControl, isSyncedAppointment, setSims]);

  useEffect(() => {
    if (!hasControl && isSyncedAppointment) {
      loadSims(sims);
    }
  }, [hasControl, isSyncedAppointment, loadSims, sims]);

  return { sims };
};
